import { render, staticRenderFns } from "./Departments.vue?vue&type=template&id=f65ac9d4"
import script from "./Departments.vue?vue&type=script&lang=js"
export * from "./Departments.vue?vue&type=script&lang=js"
import style0 from "./Departments.vue?vue&type=style&index=0&id=f65ac9d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports